import ProductAvailabilityChip from '@components/Product/ProductAvailabilityChip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { AvailabilityEnum, CompactAvailability } from '../../../products/ProductTypes';
import { OrderConditionSplitLabelParts } from '../orderCondition.utils';

interface OrderConditionSplitLabelProps extends OrderConditionSplitLabelParts {
  availability: AvailabilityEnum | CompactAvailability;
}

const OrderConditionSplitLabel = ({
  availability,
  availabilityLabel,
  classificationLabel,
}: OrderConditionSplitLabelProps) => (
  <Stack direction="row" sx={{ alignItems: 'center', columnGap: 0.75, minWidth: 0 }}>
    <ProductAvailabilityChip availability={availability} />

    {availabilityLabel && (
      <Typography noWrap variant="body2" title={availabilityLabel.toLowerCase()}>
        {availabilityLabel.toLowerCase()}
      </Typography>
    )}

    {classificationLabel && (
      <Typography noWrap variant="body2" title={classificationLabel.toLowerCase()}>
        {availabilityLabel
          ? `· ${classificationLabel.toLowerCase()}`
          : classificationLabel.toLowerCase()}
      </Typography>
    )}
  </Stack>
);

export default OrderConditionSplitLabel;
